const updateItems = [
  { title: '《长安十二时辰》全集上线，4K修复版画质惊艳', time: '2026-08-01', tag: '新上线', tagColor: 'bg-green-500' },
  { title: '暑期档专题《国产科幻崛起之路》正式发布', time: '2026-07-30', tag: '专题', tagColor: 'bg-brand-500' },
  { title: '服务器全面升级完成，全站加载速度提升40%', time: '2026-07-28', tag: '公告', tagColor: 'bg-blue-500' },
  { title: '《乘风破浪的姐姐》最新一期抢先上线', time: '2026-07-27', tag: '更新', tagColor: 'bg-warm-500' },
  { title: '动漫区新增50部经典国漫，童年回忆一次看够', time: '2026-07-25', tag: '上新', tagColor: 'bg-green-500' },
  { title: '移动端观影体验优化，支持手势控制音量亮度', time: '2026-07-23', tag: '功能', tagColor: 'bg-purple-500' },
  { title: '韩剧专区改版完成，热门韩剧一站式追更', time: '2026-07-21', tag: '改版', tagColor: 'bg-warm-500' },
  { title: '《奥本海默》高分传记电影正式登陆90影视', time: '2026-07-19', tag: '新上线', tagColor: 'bg-green-500' },
  { title: '纪录片频道全面升级，BBC、NHK精选上线', time: '2026-07-17', tag: '上新', tagColor: 'bg-green-500' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">最新快讯</h2>
            <p className="text-sm text-gray-500 mt-2">第一时间获取平台动态与内容更新</p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 border-l-2 border-gray-100 space-y-8">
              {updateItems.map((item, idx) => (
                <div key={idx} className="relative">
                  <div className="absolute -left-[33px] top-1.5 w-4 h-4 rounded-full bg-white border-2 border-brand-500 ring-4 ring-white"></div>
                  <div className="bg-gray-50 rounded-xl p-4 md:p-5 border border-gray-100 hover:border-gray-200 transition-colors duration-200 cursor-pointer">
                    <div className="flex flex-wrap items-start gap-2 mb-2">
                      <span className={`${item.tagColor} text-white text-xs font-semibold px-2 py-0.5 rounded whitespace-nowrap`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-gray-400 whitespace-nowrap">{item.time}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-gray-800 leading-snug">{item.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}